import { CuriosityNamespaceType } from '@procureai/curiosity-ui-mui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { statusColorFromRiskScore } from '../common';
import { CaclSupplierBase } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';
import {
  DataGridConfig,
  StatusChipCell,
  UseDataGridConfig,
  cellFactory,
  gridColDefFactory,
} from '~/components/DataGridCustom';
import { CuriositySourceReferenceCell } from '~/components/DataGridCustom/cells/CuriositySourceReferenceCell/CuriositySourceReferenceCell';

export const useSupplierListGridConfig: UseDataGridConfig<CaclSupplierBase> = () => {
  const { t } = useTranslation(I18nNamespace.riskSustainability);
  const { t: tColumn } = useTranslation(I18nNamespace.riskSustainability, {
    keyPrefix: 'SupplierListGrid.column',
  });

  return useMemo(() => {
    const createColumn = gridColDefFactory({ tColumn, t });
    return {
      columns: [
        createColumn({
          field: 'id',
          minWidth: 450,
          renderCell: cellFactory(CuriositySourceReferenceCell, {
            ns: CuriosityNamespaceType.SUPPLIER,
            includeLink: true,
            slug: 'risk',
          }),
        }),
        createColumn({
          field: 'score',
          renderCell: cellFactory(StatusChipCell, ({ value }) => ({
            value: value ? t(`RiskScore.${value}`) : null,
            color: statusColorFromRiskScore(value),
          })),
          minWidth: 100,
        }),
      ],
    } as DataGridConfig<CaclSupplierBase>;
  }, [t, tColumn]);
};
